import React from "react";
import { Div } from "components/Base";
import CollapsablePanel from "Portal/NewPortal/Shared/CollapsablePanel";
import { Label, Divider } from "EventLight/Common/FieldLayout";
import { Input, AdvancedWYSIWYG, Dropdown, PhoneInput } from "ui-kit/Form/View";
import Languages from "ui-kit/FieldTypes/View/Editors/Languages";

import {
  FIELD_IDS,
  FIELD_IDS_ACTIVE_ACCOUNT
} from "Portal/NewPortal/Sections/Profile/constants";

import { Mobile } from "Portal/NewPortal/Shared/MediasQuery";

import useDisplay from "Portal/NewPortal/Shared/useDisplay";

import { getFieldValueToShow } from "../../selectors";

const General = ({
  visibleFieldIds,
  lockedFieldIds,
  data = {},
  updatedFieldValues = {},
  fieldOptions,
  isViewingAsAccount = false
}) => {
  const display = useDisplay();

  return (
    <Div display="column">
      <CollapsablePanel title="General">
        {/** People Fields */}
        {!isViewingAsAccount && (
          <Div display="column" p={5} style={{ gap: 16 }} width={1}>
            {visibleFieldIds.includes(FIELD_IDS.BIOGRAPHY) ? (
              <>
                <Div display="column" style={{ gap: 8 }}>
                  <Label fs={2} color="neutral7">
                    Biography
                  </Label>
                  <AdvancedWYSIWYG
                    fieldId={FIELD_IDS.BIOGRAPHY}
                    disabled={lockedFieldIds.includes(FIELD_IDS.BIOGRAPHY)}
                    iniValue={getFieldValueToShow({
                      data,
                      updatedData: updatedFieldValues,
                      fieldId: FIELD_IDS.BIOGRAPHY,
                      defaultValue: ""
                    })}
                    placeholder={""}
                    height={200}
                  />
                </Div>
                <Divider my={0} />
              </>
            ) : null}

            {visibleFieldIds.includes(FIELD_IDS.SALUTATION) ||
            visibleFieldIds.includes(FIELD_IDS.FIRST_NAME) ||
            visibleFieldIds.includes(FIELD_IDS.LAST_NAME) ? (
              <Div
                display={display}
                width={1}
                style={{
                  gap: 20
                }}
              >
                {visibleFieldIds.includes(FIELD_IDS.SALUTATION) ? (
                  <Div display="column" width={1}>
                    <Label fs={2} color="neutral7">
                      Salutation
                    </Label>
                    <Input
                      fieldId={FIELD_IDS.SALUTATION}
                      disabled={lockedFieldIds.includes(FIELD_IDS.SALUTATION)}
                      iniValue={getFieldValueToShow({
                        data,
                        updatedData: updatedFieldValues,
                        fieldId: FIELD_IDS.SALUTATION
                      })}
                      size="big"
                      type="text"
                      inputType="outline"
                      //placeholder="Salutation..."
                    />
                  </Div>
                ) : null}

                {visibleFieldIds.includes(FIELD_IDS.FIRST_NAME) ? (
                  <Div display="column" width={1}>
                    <Label fs={2} color="neutral7">
                      First Name
                    </Label>
                    <Input
                      fieldId={FIELD_IDS.FIRST_NAME}
                      disabled={lockedFieldIds.includes(FIELD_IDS.FIRST_NAME)}
                      iniValue={getFieldValueToShow({
                        data,
                        updatedData: updatedFieldValues,
                        fieldId: FIELD_IDS.FIRST_NAME
                      })}
                      size="big"
                      type="text"
                      inputType="outline"
                      //placeholder="First Name ..."
                    />
                  </Div>
                ) : null}

                {visibleFieldIds.includes(FIELD_IDS.LAST_NAME) ? (
                  <Div display="column" width={1}>
                    <Label fs={2} color="neutral7">
                      Last Name
                    </Label>
                    <Input
                      fieldId={FIELD_IDS.LAST_NAME}
                      disabled={lockedFieldIds.includes(FIELD_IDS.LAST_NAME)}
                      iniValue={getFieldValueToShow({
                        data,
                        updatedData: updatedFieldValues,
                        fieldId: FIELD_IDS.LAST_NAME
                      })}
                      size="big"
                      type="text"
                      inputType="outline"
                      //placeholder="Last Name..."
                    />
                  </Div>
                ) : null}
              </Div>
            ) : null}

            {visibleFieldIds.includes(FIELD_IDS.HONORIFIC) ||
            visibleFieldIds.includes(FIELD_IDS.PRONOUNS) ||
            visibleFieldIds.includes(FIELD_IDS.GENDER) ? (
              <Div
                display={display}
                style={{
                  gap: 20
                }}
                width={1}
              >
                <Div display="column" {...(!Mobile ? { width: 1 } : {})}>
                  <Label fs={2} color="neutral7">
                    Honorific
                  </Label>
                  <Input
                    fieldId={FIELD_IDS.HONORIFIC}
                    disabled={lockedFieldIds.includes(FIELD_IDS.HONORIFIC)}
                    iniValue={getFieldValueToShow({
                      data,
                      updatedData: updatedFieldValues,
                      fieldId: FIELD_IDS.HONORIFIC
                    })}
                    size="big"
                    type="text"
                    inputType="outline"
                    //placeholder="Honorific..."
                  />
                </Div>
                <Div
                  display={display}
                  style={{
                    gap: 20
                  }}
                  width={1}
                >
                  <Div display="column">
                    <Label fs={2} color="neutral7">
                      Pronouns
                    </Label>
                    <Dropdown
                      fieldId={FIELD_IDS.PRONOUNS}
                      disabled={lockedFieldIds.includes(FIELD_IDS.PRONOUNS)}
                      iniValue={getFieldValueToShow({
                        data,
                        updatedData: updatedFieldValues,
                        fieldId: FIELD_IDS.PRONOUNS
                      })}
                      multipleSelect={false}
                      menuHeight={150}
                      width="200px"
                      options={fieldOptions[FIELD_IDS.PRONOUNS]}
                      usePortal
                      //placeholder="Pronouns..."
                    />
                  </Div>
                  <Div display="column">
                    <Label fs={2} color="neutral7">
                      Gender
                    </Label>
                    <Dropdown
                      fieldId={FIELD_IDS.GENDER}
                      disabled={lockedFieldIds.includes(FIELD_IDS.GENDER)}
                      iniValue={getFieldValueToShow({
                        data,
                        updatedData: updatedFieldValues,
                        fieldId: FIELD_IDS.GENDER
                      })}
                      multipleSelect={false}
                      menuHeight={150}
                      width="200px"
                      options={fieldOptions[FIELD_IDS.GENDER]}
                      usePortal
                      //placeholder="Gender..."
                    />
                  </Div>
                </Div>
                <Div width={1}></Div>
              </Div>
            ) : null}

            {visibleFieldIds.includes(FIELD_IDS.TITLE) ||
            visibleFieldIds.includes(FIELD_IDS.COMPANY) ? (
              <>
                <Divider my={0} />

                <Div
                  display={display}
                  width={1}
                  style={{
                    gap: 20
                  }}
                >
                  {visibleFieldIds.includes(FIELD_IDS.TITLE) ? (
                    <Div display="column" width={1}>
                      <Label fs={2} color="neutral7">
                        Title
                      </Label>
                      <Input
                        fieldId={FIELD_IDS.TITLE}
                        disabled={lockedFieldIds.includes(FIELD_IDS.TITLE)}
                        iniValue={getFieldValueToShow({
                          data,
                          updatedData: updatedFieldValues,
                          fieldId: FIELD_IDS.TITLE
                        })}
                        size="big"
                        type="text"
                        inputType="outline"
                        //placeholder="Title..."
                      />
                    </Div>
                  ) : null}
                  {visibleFieldIds.includes(FIELD_IDS.COMPANY) ? (
                    <Div display="column" width={1}>
                      <Label fs={2} color="neutral7">
                        Company
                      </Label>
                      <Input
                        fieldId={FIELD_IDS.COMPANY}
                        disabled={lockedFieldIds.includes(FIELD_IDS.COMPANY)}
                        iniValue={getFieldValueToShow({
                          data,
                          updatedData: updatedFieldValues,
                          fieldId: FIELD_IDS.COMPANY
                        })}
                        size="big"
                        type="text"
                        inputType="outline"
                        //placeholder="Company..."
                      />
                    </Div>
                  ) : null}
                </Div>
              </>
            ) : null}

            {visibleFieldIds.includes(FIELD_IDS.COMMUNICATION_EMAIL) ||
            visibleFieldIds.includes(FIELD_IDS.PHONE_NUMBER) ? (
              <Div
                display={display}
                width={1}
                style={{
                  gap: 20
                }}
              >
                {visibleFieldIds.includes(FIELD_IDS.COMMUNICATION_EMAIL) ? (
                  <Div display="column" width={1}>
                    <Label fs={2} color="neutral7">
                      Email
                    </Label>
                    <Input
                      fieldId={FIELD_IDS.COMMUNICATION_EMAIL}
                      disabled={lockedFieldIds.includes(
                        FIELD_IDS.COMMUNICATION_EMAIL
                      )}
                      iniValue={getFieldValueToShow({
                        data,
                        updatedData: updatedFieldValues,
                        fieldId: FIELD_IDS.COMMUNICATION_EMAIL
                      })}
                      size="big"
                      type="text"
                      inputType="outline"
                      //placeholder="Email"
                      disabled={true}
                    />
                  </Div>
                ) : null}
                {visibleFieldIds.includes(FIELD_IDS.PHONE_NUMBER) ? (
                  <Div display="column" width={1}>
                    <Label fs={2} color="neutral7">
                      Mobile Phone Number
                    </Label>
                    <PhoneInput
                      fieldId={FIELD_IDS.PHONE_NUMBER}
                      disabled={lockedFieldIds.includes(FIELD_IDS.PHONE_NUMBER)}
                      iniValue={getFieldValueToShow({
                        data,
                        updatedData: updatedFieldValues,
                        fieldId: FIELD_IDS.PHONE_NUMBER,
                        defaultValue: `+1`
                      })}
                      size="big"
                      type="text"
                      inputType="outline"
                      //placeholder="Phone Number..."
                    />
                  </Div>
                ) : null}
              </Div>
            ) : null}

            {visibleFieldIds.includes(FIELD_IDS.LANGUAGES) ||
            visibleFieldIds.includes(FIELD_IDS.REGION) ? (
              <Div
                display={display}
                width={1}
                style={{
                  gap: 20
                }}
              >
                {visibleFieldIds.includes(FIELD_IDS.LANGUAGES) ? (
                  <Div display="column" width={1}>
                    <Label fs={2} color="neutral7">
                      Languages
                    </Label>
                    <Languages
                      fieldId={FIELD_IDS.LANGUAGES}
                      disabled={lockedFieldIds.includes(FIELD_IDS.LANGUAGES)}
                      iniValue={getFieldValueToShow({
                        data,
                        updatedData: updatedFieldValues,
                        fieldId: FIELD_IDS.LANGUAGES
                      })}
                      multipleSelect={false}
                      menuHeight={150}
                      width="100%"
                      options={fieldOptions[FIELD_IDS.LANGUAGES]}
                    />
                  </Div>
                ) : null}

                {visibleFieldIds.includes(FIELD_IDS.REGION) ? (
                  <Div display="column" width={1}>
                    <Label fs={2} color="neutral7">
                      Region
                    </Label>
                    <Dropdown
                      fieldId={FIELD_IDS.REGION}
                      disabled={lockedFieldIds.includes(FIELD_IDS.REGION)}
                      iniValue={getFieldValueToShow({
                        data,
                        updatedData: updatedFieldValues,
                        fieldId: FIELD_IDS.REGION
                      })}
                      multipleSelect={false}
                      menuHeight={150}
                      width="100%"
                      options={fieldOptions[FIELD_IDS.REGION]}
                      usePortal
                    />
                  </Div>
                ) : null}
              </Div>
            ) : null}
          </Div>
        )}

        {/** Group Fields */}
        {isViewingAsAccount && (
          <Div display="column" p={5} style={{ gap: 16 }} width={1}>
            {visibleFieldIds.includes(FIELD_IDS_ACTIVE_ACCOUNT.GROUP_NAME) ? (
              <Div display="column" width={1}>
                <Label fs={2} color="neutral7">
                  Group Name
                </Label>
                <Input
                  fieldId={FIELD_IDS_ACTIVE_ACCOUNT.GROUP_NAME}
                  disabled={lockedFieldIds.includes(
                    FIELD_IDS_ACTIVE_ACCOUNT.GROUP_NAME
                  )}
                  iniValue={getFieldValueToShow({
                    data,
                    updatedData: updatedFieldValues,
                    fieldId: FIELD_IDS_ACTIVE_ACCOUNT.GROUP_NAME
                  })}
                  size="big"
                  type="text"
                  inputType="outline"
                  //placeholder="Group Name..."
                />
              </Div>
            ) : null}

            {visibleFieldIds.includes(FIELD_IDS_ACTIVE_ACCOUNT.TIER) ? (
              <Div display="column" width={1}>
                <Label fs={2} color="neutral7">
                  Select Tier
                </Label>
                <Dropdown
                  fieldId={FIELD_IDS_ACTIVE_ACCOUNT.TIER}
                  disabled={lockedFieldIds.includes(
                    FIELD_IDS_ACTIVE_ACCOUNT.TIER
                  )}
                  iniValue={getFieldValueToShow({
                    data,
                    updatedData: updatedFieldValues,
                    fieldId: FIELD_IDS_ACTIVE_ACCOUNT.TIER
                  })}
                  multipleSelect={false}
                  menuHeight={150}
                  style={{ width: "100%", zIndex: 1000 }}
                  options={fieldOptions[FIELD_IDS_ACTIVE_ACCOUNT.TIER]}
                  //placeholder="Select Tier..."
                  usePortal
                />
              </Div>
            ) : null}

            {visibleFieldIds.includes(FIELD_IDS_ACTIVE_ACCOUNT.DESCRIPTION) ? (
              <Div display="column" style={{ gap: 8 }}>
                <Label fs={2} color="neutral7">
                  Description
                </Label>
                <AdvancedWYSIWYG
                  fieldId={FIELD_IDS_ACTIVE_ACCOUNT.DESCRIPTION}
                  disabled={lockedFieldIds.includes(
                    FIELD_IDS_ACTIVE_ACCOUNT.DESCRIPTION
                  )}
                  iniValue={getFieldValueToShow({
                    data,
                    updatedData: updatedFieldValues,
                    fieldId: FIELD_IDS_ACTIVE_ACCOUNT.DESCRIPTION,
                    defaultValue: ""
                  })}
                  //placeholder={"Set the description ..."}
                  height={200}
                />
              </Div>
            ) : null}

            {visibleFieldIds.includes(FIELD_IDS_ACTIVE_ACCOUNT.PHONE_NUMBER) ? (
              <Div display="column" width={1}>
                <Label fs={2} color="neutral7">
                  Phone Number
                </Label>
                <PhoneInput
                  fieldId={FIELD_IDS_ACTIVE_ACCOUNT.PHONE_NUMBER}
                  disabled={lockedFieldIds.includes(
                    FIELD_IDS_ACTIVE_ACCOUNT.PHONE_NUMBER
                  )}
                  iniValue={getFieldValueToShow({
                    data,
                    updatedData: updatedFieldValues,
                    fieldId: FIELD_IDS_ACTIVE_ACCOUNT.PHONE_NUMBER,
                    defaultValue: `+1`
                  })}
                  size="big"
                  style={{ width: "100%", height: "40px" }}
                  type="tel"
                  inputType="outline"
                  //placeholder="Phone Number..."
                />
              </Div>
            ) : null}
          </Div>
        )}
      </CollapsablePanel>
    </Div>
  );
};

export default General;
